module.exports = __webpack_public_path__ + "img/gguri_sad.2a7774f.png";